// extracted by mini-css-extract-plugin
module.exports = {"container":"policyComplianceView_container__3wbKY"};